import React from "react";
import "@/App.css";
import "@/lib/auth"; // installs axios interceptors
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import BookingSuccess from "@/pages/BookingSuccess";
import PoliciesPage from "@/pages/PoliciesPage";
import DepositPage from "@/pages/DepositPage";
import GuestCheckIn from "@/pages/GuestCheckIn";
import AdminCheckInPoster from "@/pages/AdminCheckInPoster";
import AdminRulePosters from "@/pages/AdminRulePosters";
import AdminCheckInSheet from "@/pages/AdminCheckInSheet";
import AdminInvoice from "@/pages/AdminInvoice";
import PitchMapPage from "@/pages/PitchMapPage";
import AdminPage from "@/pages/AdminPage";
import AdminLogin from "@/pages/AdminLogin";
import {
  CustomerLogin,
  CustomerRegister,
  CustomerSetPassword,
  CustomerForgotPassword,
  CustomerAccount,
} from "@/pages/CustomerAccount";
import LodgesLincolnshire from "@/pages/LodgesLincolnshire";
import CampingLincolnshire from "@/pages/CampingLincolnshire";
import FishingLincolnshire from "@/pages/FishingLincolnshire";
import DogFriendlyLincolnshire from "@/pages/DogFriendlyLincolnshire";
import GlampingLincolnshire from "@/pages/GlampingLincolnshire";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ContentProvider } from "@/lib/content";
import ConciergeChat from "@/components/ConciergeChat";

const ChatOnPublic = () => {
  // Hide chat on admin pages
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) return null;
  return <ConciergeChat />;
};

function App() {
  return (
    <div className="App">
      {/* Global SVG filter to knock out dark background from logo image */}
      <svg width="0" height="0" style={{ position: "absolute" }}>
        <defs>
          <filter id="logo-knockout" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      2.5 2.5 2.5 0 -1.9"
            />
          </filter>
        </defs>
      </svg>
      <ErrorBoundary>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/policies" element={<PoliciesPage />} />
              <Route path="/lodges-lincolnshire" element={<LodgesLincolnshire />} />
              <Route path="/camping-lincolnshire" element={<CampingLincolnshire />} />
              <Route path="/fishing-holidays-lincolnshire" element={<FishingLincolnshire />} />
              <Route path="/dog-friendly-holidays-lincolnshire" element={<DogFriendlyLincolnshire />} />
              <Route path="/glamping-lincolnshire" element={<GlampingLincolnshire />} />
              <Route path="/pick-your-pitch" element={<PitchMapPage />} />
              <Route path="/deposit/:bookingId/:token" element={<DepositPage />} />
              <Route path="/check-in" element={<GuestCheckIn />} />
              <Route path="/check-in/:token" element={<GuestCheckIn />} />
              <Route path="/admin/checkin-poster" element={<AdminCheckInPoster />} />
              <Route path="/admin/posters" element={<AdminRulePosters />} />
              <Route path="/admin/checkin/:bookingId" element={<AdminCheckInSheet />} />
              <Route path="/admin/invoice/:bookingId" element={<AdminInvoice />} />
              <Route path="/booking/success" element={<BookingSuccess />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/account" element={<CustomerAccount />} />
              <Route path="/account/login" element={<CustomerLogin />} />
              <Route path="/account/register" element={<CustomerRegister />} />
              <Route path="/account/set-password" element={<CustomerSetPassword />} />
              <Route path="/account/reset-password" element={<CustomerSetPassword />} />
              <Route path="/account/forgot-password" element={<CustomerForgotPassword />} />
            </Routes>
            <ChatOnPublic />
          </BrowserRouter>
        </ContentProvider>
      </ErrorBoundary>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
